import { Component, OnInit, EventEmitter } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { RecommendationService } from './../recommendation.service';
import { ResidentialService } from '../../residential.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'underscore';
@Component({
  selector: 'app-initial-options',
  templateUrl: './initial-options.component.html',
  styleUrls: ['./initial-options.component.css'],
})
export class InitialOptionsComponent implements OnInit {
  // API Url
  url = environment.api_url;
  recommendationObj;
  name = 'Sam Khavari';
  discount = 0;
  accountId;
  avgMthlyUsage;
  averagePrice;
  redirect;
  residentialResponses;
  recommendations = [];
  constructor(
    private http: HttpClient,
    private recommendationService: RecommendationService,
    private router: Router,
    private residentialService: ResidentialService
  ) {
    // Set the display name
    this.accountId = this.recommendationService.hg_accountId;
    this.name = this.recommendationService.userName
      ? this.recommendationService.userName
      : 'Sam';
    this.name = this.titleCase(this.name);
  }

  titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  ngOnInit() {
    if (this.residentialService.service === 'Switching Providers') {
      this.redirect = setTimeout(() => {
        this.router.navigate([
          '/recommendation/single-product',
          this.accountId,
        ]);
      }, 3500);
      const statusObj = sessionStorage.getItem('questionStatusObj');
      const questionStatusObj = this.residentialService.questionnaireStatusObj
        ? this.residentialService.questionnaireStatusObj
        : !_.isEmpty(statusObj) && statusObj !== 'undefined'
        ? JSON.parse(statusObj)
        : null;
      if (
        !_.isEmpty(questionStatusObj) &&
        questionStatusObj.questionStatus !== 'Completed'
      ) {
        this.residentialService.currentId = questionStatusObj.questionStep;
        this.router.navigateByUrl('/residentialQues');
        this.residentialService.messageService({
          nextId: questionStatusObj.questionStep,
          questionStatus: questionStatusObj.questionStatus,
        });
      }
      if (this.recommendationService.recommendationObj) {
        this.recommendationObj = this.recommendationService.recommendationObj;
      } else {
        const recommendObj = sessionStorage.getItem('recommendedProducts');
        this.recommendationObj = JSON.parse(recommendObj);
        this.recommendationService.recommendationObj = this.recommendationObj;
      }
      if (!_.isEmpty(sessionStorage.getItem('userResponse'))) {
        this.residentialResponses = JSON.parse(
          sessionStorage.getItem('userResponse')
        );
      } else {
        this.residentialResponses = this.residentialService.userResponse;
      }
      const TermValue = _.findWhere(this.residentialResponses.userResponses, {
        res_question_id: '0026',
      });
      const term = TermValue.fieldValue.split(' ')[0];
      this.recommendations = [];
      for (
        let i = 0;
        i < this.recommendationObj.res_products_recommendations.length;
        i++
      ) {
        if (
          this.recommendationObj.res_products_recommendations[i].terms === term
        ) {
          this.recommendations.push(
            this.recommendationObj.res_products_recommendations[i]
          );
        }
      }
      if (this.recommendations.length > 0) {
        this.recommendations = this.recommendations[0];
      } else {
        this.recommendations =
          this.recommendationObj.res_products_recommendations[0];
      }
      this.recommendationService.signupProduct = this.recommendations;
      this.discount = Math.round(
        this.recommendationService.signupProduct.new_tier.discount_percent
      );
      this.avgMthlyUsage =
        this.recommendations[0] != undefined
          ? Math.round(this.recommendations[0].new_tier.ave_monthly_usage)
          : null;
      this.averagePrice =
        this.recommendations[0] != undefined
          ? (
              Number(this.recommendations[0].new_tier.ave_price_per_KWH) * 100
            ).toFixed(1)
          : null;
      this.name = this.recommendationService.userName
        ? this.recommendationService.userName
        : 'Sam';
      this.name = this.titleCase(this.name);
      if (this.residentialService.selectedType !== 'Switching Providers')
        this.router.navigate(['recommendation/single-product', this.accountId]);
    } else {
      this.router.navigate(['/recommendation/single-product', this.accountId]);
    }
  }
}
